import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
const TeamMember = () => {
  const { lname } = useParams();

  // const {lname} = useParams()


  const params = useParams()

console.log(params)
  const [member, setMember] = useState(null);

  useEffect(() => {
    // const fetchMember = async () => {
    //   const docRef = doc(db, "teamMembers", lname);
    //   const docSnap = await getDoc(docRef);
    //   if (docSnap.exists()) {
    //     setMember(docSnap.data());
    //   } else {
    //     console.log("No such document!");
    //   }
    // };



    const fetchMember = async () => {
      const q = query(collection(db, "teamMembers"), where("lname", "==", lname));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        setMember(querySnapshot.docs[0].data());
      } else {
        console.log("No such document!");
      }
    };



    fetchMember();

  }, []);

  if (!member) return <div>Loading...</div>;

  return (
    <div className="container py-5 mt-5 ">
      

<Link to="/" className="btn btn-gnbank mt-3 py-2 mb-4">
  ← Back to Home
</Link>
      <h1 className="h4">Name: {member?.name} {member?.lname}</h1>
      <p>Department: {member?.department}</p>
      <img src={member?.imageUrl} alt={`${member?.name}`} style={{ width: "200px" }} />
      <p>Bio: {member?.description}</p>
     
    </div>
  );
};

export default TeamMember;
